import { useMemo } from "react";
import { IdwTable } from "@containers/common/idw-table/idw-table";
import { resources } from "@constants/hardcoded-strings";
import { IdwTableContainer } from "@containers/common/idw-table-container/idw-table-container";
import { FormattedVerificationTransactionDetailsTrustScoreModifier } from "@idw-types/data/verification-transaction-details";
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";

type TrustScoreModifiersTableContainerProps = {
    trustScoreModifiers: Array<FormattedVerificationTransactionDetailsTrustScoreModifier>;
};

type TrustScoreModifiersTableDataRow = FormattedVerificationTransactionDetailsTrustScoreModifier & {
    assertionName: string;
    serviceOfferingName: string;
};

export const TrustScoreModifiersTableContainer = (props: TrustScoreModifiersTableContainerProps) => {
    const { trustScoreModifiers } = props;

    const trustScoreModifierTableData: Array<TrustScoreModifiersTableDataRow> = useMemo(() => {
        return trustScoreModifiers.map(trustScoreModifier => ({
            ...trustScoreModifier,
            assertionName: trustScoreModifier.assertion?.shortName || "",
            serviceOfferingName: trustScoreModifier.serviceOffering?.name || ""
        }))
    }, [trustScoreModifiers]);

    const columnHelper = createColumnHelper<TrustScoreModifiersTableDataRow>();
    const columns = useMemo(() => ([
        columnHelper.accessor("assertionName", {
            header: resources.tables.verificationTransactionDetailsTrustScoreModifiers.columns.assertion.header
        }),
        columnHelper.accessor("serviceOfferingName", {
            header: resources.tables.verificationTransactionDetailsTrustScoreModifiers.columns.serviceOffering.header
        }),
        columnHelper.accessor("assertionStatus", {
            header: resources.tables.verificationTransactionDetailsTrustScoreModifiers.columns.status.header
        }),
        columnHelper.accessor("modifierValue", {
            header: resources.tables.verificationTransactionDetailsTrustScoreModifiers.columns.modifier.header
        })
    ]), [trustScoreModifierTableData]);

    const useTableResult = useReactTable({
        columns,
        data: trustScoreModifierTableData,
        filterFns: null,
        enableFilters: false,
        sortDescFirst: false,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel()
    });

    return (
        <IdwTableContainer>
            <IdwTable
                id="trust-score-modifiers"
                useTableResult={useTableResult}
                headerColumnKeyPrefix={"trust-score-modifiers"}
            />
        </IdwTableContainer>
    );
};